import { render } from "./DataTables.vue?vue&type=template&id=71299a4f"
import script from "./DataTables.vue?vue&type=script&lang=js"
export * from "./DataTables.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__